(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCategoryDetailController', ProviderCategoryDetailController);

    ProviderCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProviderCategory', 'ProviderCountry'];

    function ProviderCategoryDetailController($scope, $rootScope, $stateParams, previousState, entity, ProviderCategory, ProviderCountry) {
        var vm = this;

        vm.providerCategory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:providerCategoryUpdate', function(event, result) {
            vm.providerCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
